import { forwardRef } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import type {
  TTooltipTriggerElement,
  TTooltipTriggerProps,
} from "@/ui/components/overlay/Tooltip/Tooltip.config";

export const TooltipTrigger = forwardRef<TTooltipTriggerElement, TTooltipTriggerProps>(
  (props, ref) => (
    <TooltipPrimitive.Trigger
      ref={ref}
      data-component="TooltipTrigger"
      {...props}
    />
  ),
);

TooltipTrigger.displayName = TooltipPrimitive.Trigger.displayName;
